import { amex, diners, discover, generic, jcb, mastercard, visa } from '@/assets/images/cardLogos';

const CREDIT_CARD_MAPPING: Record<string, CreditCardIssuer> = {
  visa: 'VISA',
  mastercard: 'MASTERCARD',
  'american-express': 'AMEX',
  'diners-club': 'DINERS-CLUB',
  discover: 'DISCOVER',
  jcb: 'JCB'
};

export type CreditCardIssuer = 'VISA' | 'MASTERCARD' | 'AMEX' | 'DINERS-CLUB' | 'DISCOVER' | 'JCB';

export const getCreditCardLogo = (type?: CreditCardIssuer | string) => {
  const normalizedType = type ? CREDIT_CARD_MAPPING[type] || type : undefined;

  switch (normalizedType) {
    case 'VISA':
      return visa;
    case 'MASTERCARD':
      return mastercard;
    case 'AMEX':
      return amex;
    case 'DINERS-CLUB':
      return diners;
    case 'DISCOVER':
      return discover;
    case 'JCB':
      return jcb;
    default:
      return generic;
  }
};
